// Imports => Utilities
import {AcLockObject} from '../utilities/ac-lock-object';

export const ENVIRONMENTS = AcLockObject({
  DEV: 'dev',
  DEVELOPMENT: 'development',
  TEST: 'test',
  ACCEPT: 'accept',
  STAGING: 'staging',
  SANDBOX: 'sandbox',
  PRODUCTION: 'production',
  LOCAL: 'local',
});

export default ENVIRONMENTS;
